import i18n from '../i18n';
import { toast } from '../ui/toast-store';
import type { WriteObserver } from './client';
import { successKey } from './toast-messages';

/**
 * Tell the person how a write went. Called by the API client after every write, and by the few
 * uploads that use `fetch` directly (they carry a file as the body, so they cannot go through it).
 *
 * A success is worded by `successKey`; a failure carries the server's own plain sentence
 * (`plain-error.ts`), because "the invoice reference is already used" is the useful part, not
 * "something went wrong". A 401 is not announced: the session provider already takes the person to
 * sign-in, and a red toast on top of that would be a second voice saying the same thing.
 */
export const announceWrite: WriteObserver = (method, path, outcome) => {
  if (outcome.ok) {
    const key = successKey(method, path);
    if (key) toast.success(i18n.t(key));
    return;
  }
  if (outcome.status === 401 || method.toUpperCase() === 'GET') return;
  toast.error(outcome.message);
};
